@if (isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
} @else {
  <div>
    @if ((packs?.length <= 0 && !customEnabled)) {
      <my-ibox boxTitle="Sticker Packs">
        <div class="my-ibox-content">
          <h5 style="text-align: center;">{{'Sticker packs are not enabled on this Dimension instance.' | translate}}</h5>
        </div>
      </my-ibox>
    }
    @if (customEnabled) {
      <my-ibox boxTitle="Add Sticker Packs">
        <div class="my-ibox-content">
          <form (submit)="importPack()" novalidate name="importForm">
            <label class="label-block">
              Stickerpack URL
              <span class="text-muted">{{'Start a conversation with' | translate}} {{stickerBot}} {{'to create your own stickerpack.' | translate}}</span>
              <input type="text" class="form-control" name="packUrl"
                placeholder="{{managerUrl}}/pack/..."
                [(ngModel)]="packUrl" [disabled]="isImporting"/>
            </label>
            <div style="margin-top: 25px">
              <button type="submit" class="btn btn-sm btn-success" [disabled]="isImporting">
                <i class="fa fa-plus"></i> {{'Add stickerpack' | translate}}
              </button>
            </div>
          </form>
        </div>
      </my-ibox>
    }
    @if ((packs?.length > 0)) {
      <my-ibox boxTitle="Sticker Packs">
        <div class="my-ibox-content">
          @for (pack of packs; track pack) {
            <div class="pack">
              @if (!pack.isAnimated) {
                <img alt="{{pack.displayName}}" [src]="getThumbnailUrl(pack.avatarUrl, 120, 120)" width="120" height="120"/>
              }
              @if (pack.isAnimated) {
                <ng-lottie [options]="pack.animationOpts" containerClass="lottie-box" [styles]="{display: 'inline-block'}" width="120px" height="120px"></ng-lottie>
              }
              <div class="caption">
                <ui-switch [checked]="pack.isSelected" size="medium" [disabled]="isUpdating"
                (change)="toggleSelected(pack)" class="toggle-switch"></ui-switch>
                <span class="name">{{ pack.displayName | translate}}</span>
                <span class="description">{{ pack.description | translate}}</span>
                @if (pack.author.type !== 'none') {
                  <span class="author">{{'Created by' | translate}} <a
                  [href]="pack.author.reference">{{ pack.author.name }}</a> {{'under' | translate}} </span>
                }
                <span class="license"><a [href]="pack.license.urlPath">{{ pack.license.name }}</a></span>
              </div>
            </div>
          }
        </div>
      </my-ibox>
    }
  </div>
}
